import SignW8BENContractModal from './SignW8BENContractModal';

export default SignW8BENContractModal;
